import React, { useState } from "react"
import AddFarmArea from "./AddFarmArea"
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material"
import { useMutation, gql } from "@apollo/client"
import AddFarmAreaInput from "./AddFarmAreaInput"

// An Area looks like:
// {
//     farm_id: 1
//     description: "Some farm area"
//     perimeter: {
//         type: "Polygon",
//         coordinates: [[[-34.99, -242.663], [-34.99, -242.66], [-35, -242.66], [-35, -242.663], [-34.99, -242.663]]]
//     }
// }

const ADD_FARM_AREA_MUTATION = gql`
  mutation AddArea($insertObjects: [area_insert_input!]!) {
    insert_area(objects: $insertObjects) {
      returning {
        id
      }
    }
  }
`

const UPDATE_GEO_LOCATION = gql`
  mutation update_location($pk_columns: [int!]!, $geo_json: geography!) {
    update_geo_location_by_pk(
      pk_columns: $pk_columns
      _set: { geo_json: $geo_json, updated_at: "now()" }
    ) {
      id
    }
  }
`

export default function AddFarmAreaIndex({
  open,
  setAddingArea,
  farmId,
  farmAreaGeoJSON,
}) {
  const [addFarmArea] = useMutation(ADD_FARM_AREA_MUTATION)
  const [updateLocation] = useMutation(UPDATE_GEO_LOCATION)
  const [features, setFeatures] = useState({})
  const [mode, setMode] = useState("gps")
  const upsertAreas = (newAreas) => {
    const areasArray = Object.keys(newAreas).map((a) => {
      return newAreas[a]
    })

    const areasForUpdate = areasArray.filter(
      (area) => typeof area.id === "number"
    )
    const areasForInsert = areasArray.filter(
      (area) => typeof area.id !== "number"
    )

    areasForUpdate.forEach((area) => {
      updateLocation({
        variables: {
          pk_columns: [area.geo_location.id],
          geo_json: area.geometry,
        },
      })
    })

    addFarmArea({
      variables: {
        insertObjects: areasForInsert.map((area) => ({
          farm_id: farmId,
          description: area.properties?.description || "",
          geo_location: { data: { geo_json: area.geometry } },
        })),
      },
    })
  }

  const saveChanges = () => {
    upsertAreas(features)
    setFeatures({})
    setAddingArea(false)
  }

  const handleModeChange = (event, newMode) => {
    setMode(newMode)
  }

  return (
    <Dialog open={open}>
      <DialogTitle>Add a new Farm Area</DialogTitle>
      <DialogContent>
        <ToggleButtonGroup value={mode} onChange={handleModeChange} exclusive>
          <ToggleButton value="gps">GPS Input</ToggleButton>
          <ToggleButton value="map">Map Draw</ToggleButton>
        </ToggleButtonGroup>
        {mode === "map" && (
          <AddFarmArea
            farmAreaGeoJSON={farmAreaGeoJSON}
            features={features}
            setFeatures={setFeatures}
          />
        )}
        {mode === "gps" && (
          <AddFarmAreaInput features={features} setFeatures={setFeatures} />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setAddingArea(false)
            setFeatures({})
          }}
        >
          Discard Changes
        </Button>

        <Button onClick={saveChanges}>Save Changes</Button>
      </DialogActions>
    </Dialog>
  )
}
